import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { Cartridge, MillSize } from "../models/Cartridge";

export const getCartridges = async ({
	id = null,
	millSizeId = null,
}: {
	id?: number | null;
	millSizeId?: number | null;
} = {}): Promise<Cartridge[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "OnlyActives", value: false }];

	if (id) {
		parameters.push({ name: "Id", value: id });
	}
	if (millSizeId) {
		parameters.push({ name: "MillSizeId", value: millSizeId });
	}

	const resp = await apiService.callV2("[MILL].[GetCartridges]", parameters);

	if (resp.ok) {
		const rows = get(resp, "data.tables[0].rows", []) as Cartridge[];
		return rows;
	}
	throw new Error(resp.message || "Error fetching cartridges");
};

export const upsertCartridge = async (
	cartridge: Cartridge,
): Promise<Cartridge> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "Id", value: cartridge.Id },
		{ name: "Name", value: cartridge.Name },
		{ name: "Description", value: cartridge.Description },
		{ name: "MillSizeId", value: cartridge.MillSizeId },
		{ name: "Active", value: cartridge.Active },
	];

	const resp = await apiService.callV2("[MILL].[UpsertCartridge]", parameters);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows[0]", null) as Cartridge;
	}
	throw new Error(resp.message || "Error saving cartridge");
};

export const removeCartridge = async (id: number): Promise<void> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "Id", value: id }];

	const resp = await apiService.callV2("[MILL].[RemoveCartridge]", parameters);

	if (!resp.ok) {
		throw new Error(resp.message || "Error deleting cartridge");
	}
};

export const getMillSizes = async ({
	onlyActives = true,
}: {
	onlyActives?: boolean;
} = {}): Promise<MillSize[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "OnlyActives", value: onlyActives },
	];

	const resp = await apiService.callV2("[MILL].[GetMillSizes]", parameters);

	if (resp.ok) {
		const rows = get(resp, "data.tables[0].rows", []) as MillSize[];
		return rows;
	}
	throw new Error(resp.message || "Error fetching mill sizes");
};
